var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5625 0.4375H1.4375C0.988086 0.4375 0.625 0.800586 0.625 1.25V17.5C0.625 17.9494 0.988086 18.3125 1.4375 18.3125H22.5625C23.0119 18.3125 23.375 17.9494 23.375 17.5V1.25C23.375 0.800586 23.0119 0.4375 22.5625 0.4375ZM21.5469 3.25078V16.4844H2.45312V3.25078L1.75234 2.70488L2.7502 1.42266L3.83691 2.26816H20.1656L21.2523 1.42266L22.2502 2.70488L21.5469 3.25078ZM20.1656 2.26562L12 8.61328L3.83437 2.26562L2.74766 1.42012L1.7498 2.70234L2.45059 3.24824L11.124 9.99199C11.3735 10.1858 11.6803 10.291 11.9962 10.291C12.3121 10.291 12.6189 10.1858 12.8684 9.99199L21.5469 3.25078L22.2477 2.70488L21.2498 1.42266L20.1656 2.26562Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.b8198e497218c6f211d36db8ec53ba12.svg";
export { ForwardRef as ReactComponent };